"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _table = _interopRequireDefault(require("../../table"));

var _checkbox = _interopRequireDefault(require("../../checkbox"));

var _typography = _interopRequireDefault(require("../../typography"));

var _utils = require("../utils");

var _constants = require("../constants");

var _labelIcon = require("./labelIcon");

var _radio = require("../../radio/radio");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NodesTable = function NodesTable(_ref) {
  var _rows;

  var nodes = _ref.nodes,
      updateCount = _ref.updateCount,
      filter = _ref.filter,
      searchText = _ref.searchText,
      readOnly = _ref.readOnly,
      handleCheckboxClick = _ref.handleCheckboxClick,
      hideCheckboxes = _ref.hideCheckboxes,
      singleSelect = _ref.singleSelect,
      singleSelectRadio = _ref.singleSelectRadio,
      allowOnlyLeafSelection = _ref.allowOnlyLeafSelection,
      _ref$allowRootSelecti = _ref.allowRootSelection,
      allowRootSelection = _ref$allowRootSelecti === void 0 ? true : _ref$allowRootSelecti,
      showCreatedDate = _ref.showCreatedDate,
      _ref$rootLeafNodesFir = _ref.rootLeafNodesFirst,
      rootLeafNodesFirst = _ref$rootLeafNodesFir === void 0 ? false : _ref$rootLeafNodesFir;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1];

  (0, _react.useEffect)(function () {
    var nodesToRender = (0, _utils.getNodesToRender)(_toConsumableArray(nodes), singleSelect, rootLeafNodesFirst);
    setTableData((0, _utils.prepareDataForTable)(nodesToRender, filter === _constants.SHOW_SELECTED, searchText));
  }, [updateCount, filter, searchText]);

  var handleSorting = function handleSorting(sortOrder, sortBy) {
    var sortedNodes = _toConsumableArray(nodes);

    if (sortOrder !== _constants.unsorted) {
      sortedNodes.sort(function (a, b) {
        if (a[sortBy] > b[sortBy]) {
          return sortOrder === _constants.asc ? 1 : -1;
        }

        if (b[sortBy] > a[sortBy]) {
          return sortOrder === _constants.asc ? -1 : 1;
        }

        return 0;
      });
    }

    setTableData((0, _utils.prepareDataForTable)(sortedNodes, filter === _constants.SHOW_SELECTED, searchText));
  };

  var renderName = function renderName(row) {
    var _parentNodeClass, _textNodeClass, _row$leftIcon, _row$leftIcon2, _row$leftIcon3, _row$leftIcon4, _row$rightIcon, _row$rightIcon2, _row$rightIcon3;

    var isLeaf = row.type === 'leaf';
    var isRowDisable = singleSelect && singleSelectRadio && (row === null || row === void 0 ? void 0 : row.disabled);
    var parentNodeClass = (_parentNodeClass = {}, _defineProperty(_parentNodeClass, _constants.TreeNodeClasses.tableNameCellContent, true), _defineProperty(_parentNodeClass, _constants.TreeNodeClasses.disabledRow, isRowDisable), _parentNodeClass);
    var textNodeClass = (_textNodeClass = {}, _defineProperty(_textNodeClass, _constants.TreeNodeClasses.parentText, true), _defineProperty(_textNodeClass, _constants.TreeNodeClasses.disabledRow, isRowDisable), _textNodeClass);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_objectSpread({}, parentNodeClass))
    }, !(hideCheckboxes || singleSelect) && /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      checked: row.checked,
      disabled: readOnly || row.disabled,
      indeterminate: row.indeterminate,
      onChange: function onChange(_ref2) {
        var target = _ref2.target;
        return handleCheckboxClick(row._id, target.checked);
      }
    }), singleSelectRadio && singleSelect && /*#__PURE__*/_react.default.createElement(_radio.RadioButton, {
      onChange: function onChange(event) {
        handleCheckboxClick(row._id, event.target.checked);
      },
      selected: row === null || row === void 0 ? void 0 : row.checked,
      disabled: row === null || row === void 0 ? void 0 : row.disabled
    }), /*#__PURE__*/_react.default.createElement(_labelIcon.LabelIcon, {
      isLeaf: isLeaf,
      iconSource: row === null || row === void 0 ? void 0 : (_row$leftIcon = row.leftIcon) === null || _row$leftIcon === void 0 ? void 0 : _row$leftIcon.icon,
      tooltip: row === null || row === void 0 ? void 0 : (_row$leftIcon2 = row.leftIcon) === null || _row$leftIcon2 === void 0 ? void 0 : _row$leftIcon2.tooltip,
      useDefaultIcon: row !== null && row !== void 0 && (_row$leftIcon3 = row.leftIcon) !== null && _row$leftIcon3 !== void 0 && _row$leftIcon3.icon ? false : true,
      onClick: row === null || row === void 0 ? void 0 : (_row$leftIcon4 = row.leftIcon) === null || _row$leftIcon4 === void 0 ? void 0 : _row$leftIcon4.onClick,
      disabled: singleSelect && singleSelectRadio && (row === null || row === void 0 ? void 0 : row.disabled)
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_objectSpread({}, textNodeClass))
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: !isLeaf || row.highlighted ? 'label2' : 'label1'
    }, row.label, " ", row.highlighted ? '*' : '')), /*#__PURE__*/_react.default.createElement(_labelIcon.LabelIcon, {
      iconSource: row === null || row === void 0 ? void 0 : (_row$rightIcon = row.rightIcon) === null || _row$rightIcon === void 0 ? void 0 : _row$rightIcon.icon,
      tooltip: row === null || row === void 0 ? void 0 : (_row$rightIcon2 = row.rightIcon) === null || _row$rightIcon2 === void 0 ? void 0 : _row$rightIcon2.tooltip,
      onClick: row === null || row === void 0 ? void 0 : (_row$rightIcon3 = row.rightIcon) === null || _row$rightIcon3 === void 0 ? void 0 : _row$rightIcon3.onClick
    }));
  };

  var renderCreatedDate = function renderCreatedDate(row) {
    return /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: 'label1'
    }, (0, _utils.getDisplayDate)(row === null || row === void 0 ? void 0 : row.createdDate));
  };

  var columns = [{
    field: 'label',
    headerName: 'Name',
    sortable: true,
    renderColumn: renderName
  }, {
    field: 'path',
    headerName: 'Path',
    sortable: true
  }];

  if (showCreatedDate) {
    columns.push({
      field: 'createdDate',
      headerName: 'Created Date',
      sortable: true,
      renderColumn: renderCreatedDate
    });
  }

  var rows = tableData;

  if (allowOnlyLeafSelection) {
    rows = tableData.filter(function (data) {
      return data.type === 'leaf' || allowRootSelection && data._id === '0';
    });
  }

  var singleSelectTableProps = {
    allowRowSelect: true,
    highlightedRow: (_rows = rows) === null || _rows === void 0 ? void 0 : _rows.find(function (row) {
      return row.checked;
    }),
    onRowSelect: function onRowSelect(clickedRow) {
      if (singleSelect && singleSelectRadio && clickedRow !== null && clickedRow !== void 0 && clickedRow.disabled) {
        return;
      }

      handleCheckboxClick(clickedRow._id, true);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_table.default, _extends({
    rows: rows,
    sortHandler: handleSorting,
    columns: columns
  }, singleSelect ? singleSelectTableProps : {}));
};

var _default = NodesTable;
exports.default = _default;